/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './schedule.reducer';

export const ScheduleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const scheduleEntity = useAppSelector(state => state.schedule.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="scheduleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.schedule.detail.title">Schedule</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.schedule.id">Id</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.id}</dd>
          <dt>
            <span id="scheduleDate">
              <Translate contentKey="tinyMedicRestApp.schedule.scheduleDate">Schedule Date</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.scheduleDate}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.schedule.active">Active</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.schedule.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.schedule.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.schedule.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.schedule.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.timestampEntry}</dd>
          <dt>
            <span id="served">
              <Translate contentKey="tinyMedicRestApp.schedule.served">Served</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.served ? 'true' : 'false'}</dd>
          <dt>
            <span id="hoursServed">
              <Translate contentKey="tinyMedicRestApp.schedule.hoursServed">Hours Served</Translate>
            </span>
          </dt>
          <dd>{scheduleEntity.hoursServed}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schedule.nurse">Nurse</Translate>
          </dt>
          <dd>{scheduleEntity.nurse ? scheduleEntity.nurse.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schedule.shift">Shift</Translate>
          </dt>
          <dd>{scheduleEntity.shift ? scheduleEntity.shift.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schedule.department">Department</Translate>
          </dt>
          <dd>{scheduleEntity.department ? scheduleEntity.department.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schedule.hospital">Hospital</Translate>
          </dt>
          <dd>{scheduleEntity.hospital ? scheduleEntity.hospital.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.schedule.ward">Ward</Translate>
          </dt>
          <dd>{scheduleEntity.ward ? scheduleEntity.ward.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/schedule" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/schedule/${scheduleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ScheduleDetail;
